import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import validator from "validator";
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
import LoginBg from "./../images/bg-sommar.jpg";
import Logo from "./../images/sustain-change-logo.png";
// import LogoIcon from "./../images/logo-icon.png";
import configVars from "../config";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import fetch from 'cross-fetch';

const Login = () => {
  const [userEmail, setUserEmail] = useState("");
  const [userPass, setUserPass] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies([
    "sustainyou_user_jwt",
    "sustainyou_jwt_issued",
    "sustainyou_jwt_expire",
  ]);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [translation] = useTranslation("translations");

  //const [bgUrl, setBgUrl] = useState('');

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if ( window.location.pathname !== '/login/' && window.location.pathname !== '/login' && window.location.pathname !== '/' ) {
      setCookie("redirect_to", window.location.pathname, { path: "/" });
    }

    if (urlParams.get("logout")) {
      const logout = urlParams.get("logout");

      if (logout === "true") {
        if (cookies.sustainyou_user_jwt) {
          removeCookie("sustainyou_user_jwt", { path: "/" });
        }

        if (cookies.sustainyou_jwt_issued) {
          removeCookie("sustainyou_jwt_issued", { path: "/" });
        }

        if (cookies.sustainyou_jwt_expire) {
          removeCookie("sustainyou_jwt_expire", { path: "/" });
        }

        removeCookie("sc_user_lang", { path: "/" });

          (async () => {

            if ( cookies.sustainyou_user_jwt ) {

              try {
                const response = await fetch(
                  `${configVars.apiUrl}simple-jwt-login/v1/auth/revoke/`,
                  {
                    method: "POST",
                    headers: {
                      Authorization: `Basic ${configVars.auth}`,
                    },
                    body: JSON.stringify({
                      JWT: cookies.sustainyou_user_jwt,
                    }),
                  }
                );
                const authResponse = await response.json();
          
                if (authResponse) {
  
                  localStorage.clear();
                  window.location.href = "/login";
                }
              } catch (error) {
                return error;
              }

            } else {
              return;
            }

            localStorage.clear();
            window.location.href = "/login";

          })()
      }
    }

      //setBgUrl(LoginBg);

  }, [cookies, removeCookie, setCookie]);

  // const treatAsUTC = (date) => {
  //   const result = new Date(date);
  //   result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
  //   return result;
  // };

  // const daysBetween = (startDate, endDate) => {
  //   var millisecondsPerDay = 24 * 60 * 60 * 1000;
  //   return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
  // };

  const saveJwtCookies = (jwt) => {
    if (!jwt) return;

    setCookie("sustainyou_user_jwt", jwt, { path: "/" });

    const jwtDecoded = jwt_decode(jwt);

    if (jwtDecoded.iat) {
      setCookie("sustainyou_jwt_issued", jwtDecoded.iat, { path: "/" });
    }

    if (jwtDecoded.exp) {
      setCookie("sustainyou_jwt_expire", jwtDecoded.exp, { path: "/" });
    }
  };

  const JWTAuth = async () => {
    try {
      const response = await fetch(
        `${configVars.apiUrl}simple-jwt-login/v1/auth`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${configVars.auth}`,
          },
          body: JSON.stringify({
            email: userEmail,
            password: userPass,
          }),
        }
      );
      const authResponse = await response.json();

      if (authResponse) {
        if (authResponse.success) {
          if (authResponse.data.jwt) {
            localStorage.removeItem("sustainchange_single_board_expiry");
            localStorage.removeItem("sustainchange_all_boards_expiry");
            saveJwtCookies(authResponse.data.jwt);
          }

          setIsUserLoggedIn(true);
        }

        return authResponse;
      }
    } catch (error) {
      return error;
    }
  };

  const authenticateUser = async () => {
    setIsError(false);
    setErrorMsg("");

    JWTAuth().then((response) => {
      if (response.ok) {
        // console.log("user authenticated");
      } else {
        setIsError(true);
        setErrorMsg(translation("incorrect_email_pwd"));
        window.location.href = "/";
      }

      setProcessing(false);
    });
  };

  const handleLogin = (e) => {
    setIsError(false);
    setEmailError(false);
    setPasswordError(false);
    setErrorMsg("");

    e.preventDefault();

    if (!userEmail.toString().trim().length) {
      setIsError(true);
      setErrorMsg(translation("fill_required_fields"));
      setEmailError(true);
    }

    if (!userPass.toString().trim().length) {
      setIsError(true);
      setErrorMsg(translation("fill_required_fields"));
      setPasswordError(true);
    }

    if (
      !userEmail.toString().trim().length ||
      !userPass.toString().trim().length
    ) {
      return;
    }

    if (!validator.isEmail(userEmail)) {
      setIsError(true);
      setErrorMsg(translation("enter_valid_email"));
      setEmailError(true);

      return;
    }

    setProcessing(true);

    authenticateUser();
  };

  if (isUserLoggedIn) {
    return <Redirect to="/?loggedin=true" />;
  }

  return (
    <div
      className="login-wrap min-vh-100 min-vw-100 d-flex align-items-center"
      style={{ backgroundImage: `url(${LoginBg})` }}
    >
      <Helmet>
        <title>Login</title>
        <meta name="description" content="" />
      </Helmet>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-5">
            <div className="d-flex flex-column align-items-center px-4 py-4 py-lg-5 h-100 justify-content-center border border-1 shadow bg-white">
              <div className="mb-4 d-flex flex-column justify-content-center align-items-center">
                <h3 className="mb-4">Välkommen till</h3>
                <img
                  src={Logo}
                  className="img-fluid"
                  style={{ maxWidth: "250px" }}
                  alt="Login"
                />
              </div>

              {isError && (
                <div className="my-3 w-100">
                  <div className="alert alert-secondary" role="alert">
                    {errorMsg}
                  </div>
                </div>
              )}

              <form className="w-100" onSubmit={(e) => handleLogin(e)}>

                <div className="my-3 w-100">
                  <input
                    type="email"
                    className={`form-control ${emailError ? "is-invalid" : ""}`}
                    id="user_email"
                    placeholder={translation("enter_email")}
                    value={userEmail}
                    onChange={(e) => {
                      setUserEmail(e.target.value);
                    }}
                  />
                </div>
                <div className="mb-3 w-100">
                  <input
                    type="password"
                    className={`form-control ${
                      passwordError ? "is-invalid" : ""
                    }`}
                    id="user_password"
                    placeholder={translation("enter_pswd")}
                    value={userPass}
                    onChange={(e) => {
                      setUserPass(e.target.value);
                    }}
                  />
                </div>
                <div className="d-flex mt-3 mb-3 w-100 justify-content-between">
                  <div className="form-check form-switch mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="remember_me"
                      checked={rememberMe}
                      onChange={(e) => {
                        setRememberMe(e.target.checked);
                      }}
                    />
                    <label className="form-check-label" htmlFor="remember_me">
                      {translation("remember_me")}
                    </label>
                  </div>
                  <a href="/reset-password/">
                    <i>{translation("forgot_pwd")}</i>
                  </a>
                </div>

                <div className="d-flex w-100 justify-content-center">
                  <button
                    type="submit"
                    className="btn btn-primary text-white px-5 px-lg-6 rounded-pill"
                  >
                    {processing && (
                      <div
                        className="spinner-border text-light spinner-border-sm me-2"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                    <span>{translation("login")}</span>
                </button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
